import { render, staticRenderFns } from "./BottomMessage.vue?vue&type=template&id=aad508ae&scoped=true"
import script from "./BottomMessage.vue?vue&type=script&lang=js"
export * from "./BottomMessage.vue?vue&type=script&lang=js"
import style0 from "./BottomMessage.vue?vue&type=style&index=0&id=aad508ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aad508ae",
  null
  
)

export default component.exports